export default "__VITE_ASSET__DgX520Cu__"